import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import JSON5 from 'json5';

function BaeminMenuCopy() {
  const navigate = useNavigate();
  const [inputText, setInputText] = useState('');

  const createNewExcelWithDayAndName = async () => {
    let parsedData;
    try {
      let cleanText = inputText.trim();

      if (cleanText.startsWith('<html')) {
        const scriptMatch = cleanText.match(/<script[^>]*>([\s\S]*?)<\/script>/i);
        if (!scriptMatch) {
          alert('HTML 내 <script> 태그를 찾을 수 없습니다.');
          return;
        }
        cleanText = scriptMatch[1].trim();
      }

      const apolloMatch = cleanText.match(/window\.__APOLLO_STATE__\s*=\s*({[\s\S]*?});?\s*$/m);
      if (!apolloMatch) {
        alert('window.__APOLLO_STATE__ 데이터를 찾을 수 없습니다.');
        return;
      }
      cleanText = apolloMatch[1]
        .replace(/\\u002F/g, '/')
        .replace(/:\s*undefined/g, ': null')
        .replace(/:\s*NaN/g, ': null')
        .replace(/:\s*Infinity/g, ': null')
        .replace(/,\s*]/g, ']')
        .replace(/,\s*}/g, '}');

      const openBraces = (cleanText.match(/{/g) || []).length;
      const closeBraces = (cleanText.match(/}/g) || []).length;
      if (openBraces > closeBraces) cleanText += '}'.repeat(openBraces - closeBraces);

      parsedData = JSON5.parse(cleanText);
    } catch (err) {
      console.error('파싱 실패:', err);
      alert('잘못된 JSON 데이터입니다.');
      return;
    }

    const menuGroups = Object.values(parsedData).filter(
      (item) => item.__typename === 'PlaceDetail_BaeminMenuGroup'
    );

    const menus = Object.entries(parsedData)
      .filter(
        ([key, value]) =>
          key.startsWith('PlaceDetail_BaeminMenu:') && value.__typename === 'PlaceDetail_BaeminMenu'
      )
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Menu');
    worksheet.columns = [
      { header: '카테고리 이름', key: 'category', width: 30 },
      { header: '메뉴 이름', key: 'menu', width: 40 },
      { header: '가격', key: 'price', width: 15 },
      { header: '옵션 그룹', key: 'optionGroup', width: 30 },
      { header: '옵션 이름', key: 'optionName', width: 30 },
      { header: '옵션 가격', key: 'optionPrice', width: 15 },
    ];

    menuGroups.forEach((group) => {
      const categoryName = group.name;
      group.menus.forEach(({ __ref }) => {
        const menu = menus[__ref];
        if (!menu) return;
        const baseRow = {
          category: categoryName,
          menu: menu.name,
          price: menu.price,
        };

        if (menu.optionGroups?.length) {
          menu.optionGroups.forEach((optGroup) => {
            const groupName = optGroup.name || '';
            if (optGroup.options?.length) {
              optGroup.options.forEach((option) => {
                worksheet.addRow({
                  ...baseRow,
                  optionGroup: groupName,
                  optionName: option.name || '',
                  optionPrice: option.price || '',
                });
              });
            } else {
              worksheet.addRow({
                ...baseRow,
                optionGroup: groupName,
                optionName: '',
                optionPrice: '',
              });
            }
          });
        } else {
          worksheet.addRow({
            ...baseRow,
            optionGroup: '',
            optionName: '',
            optionPrice: '',
          });
        }
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const today = new Date();
    const filename = `배민메뉴_${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}.xlsx`;
    saveAs(blob, filename);
  };

  return (
    <div className="p-4 max-w-3xl mx-auto">
      <button onClick={() => navigate('/')}>메인으로</button>
      <h1 className="font-bold text-xl my-4">JSON → 엑셀 생성</h1>
      <textarea
        rows={12}
        className="w-full border border-gray-300 p-2 rounded-md text-sm font-mono text-black"
        placeholder="콘솔 데이터 붙여넣기"
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
      />
      <button
        className="bg-[#ffd29a] hover:bg-[#ffa027] border-2 border-[#ffa027] px-4 py-2 rounded-full mt-4"
        onClick={createNewExcelWithDayAndName}
      >
        엑셀 생성
      </button>
    </div>
  );
}

export default BaeminMenuCopy;
